import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "@moeindal/base-raiko-panel-components";

export class UnionService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getUnionBasicInformation(fundID) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/union-financial-information`
            ).then(resolve).catch(reject)
        })
    }
    getFundTransactions(fundID,page, size, startDateValue, endDateValue) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `unions/funds/${fundID}/transactions`,
                {
                    page,
                    size,
                    "start-date": startDateValue.length === 10 ? convertPersianDateToUniversalDate(startDateValue) : "",
                    "end-date": endDateValue.length === 10 ? convertPersianDateToUniversalDate(endDateValue) : "",
                }
            ).then(resolve).catch(reject)
        })
    }
}